export default __webpack_public_path__ + "static/media/10-6.05451f44.png";